import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Avatar from 'flarum/common/components/Avatar';
/** System post for "battle started": player avatars, names, and W/L/D stats. */
export default class ArenaBattleStartPost extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "challengerUser", null);
    _defineProperty(this, "opponentUser", null);
    _defineProperty(this, "loaded", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.resolveUsers();
  }
  async resolveUsers() {
    const content = this.attrs.post.content();
    if (!content) return;
    const fromStore = id => {
      var _app$store$getById;
      return (_app$store$getById = app.store.getById('users', String(id))) != null ? _app$store$getById : null;
    };
    this.challengerUser = fromStore(content.challengerId);
    this.opponentUser = fromStore(content.opponentId);
    if (!this.challengerUser || !this.opponentUser) {
      try {
        const loads = [];
        if (!this.challengerUser) loads.push(app.store.find('users', content.challengerId).catch(() => null));
        if (!this.opponentUser) loads.push(app.store.find('users', content.opponentId).catch(() => null));
        await Promise.all(loads);
        this.challengerUser = fromStore(content.challengerId);
        this.opponentUser = fromStore(content.opponentId);
      } catch (_unused) {/* ignore */}
    }
    this.loaded = true;
    m.redraw();
  }
  playerColumn(user, fallbackName) {
    var _user$attribute, _name$, _stats$wins, _stats$losses, _stats$draws;
    const name = (user == null ? void 0 : user.displayName()) || fallbackName;
    const stats = (_user$attribute = user == null ? void 0 : user.attribute('arenaStats')) != null ? _user$attribute : null;
    const profileUrl = user ? app.route('user', {
      username: user.username()
    }) : null;
    const nameEl = profileUrl ? m("a", {
      className: "ArenaBattleStartPost-playerName",
      href: profileUrl,
      onclick: e => {
        e.preventDefault();
        m.route.set(profileUrl);
      }
    }, name) : m("div", {
      className: "ArenaBattleStartPost-playerName"
    }, name);
    return m("div", {
      className: "ArenaBattleStartPost-player"
    }, m("div", {
      className: "ArenaBattleStartPost-avatar"
    }, user ? m(Avatar, {
      user: user
    }) : m("span", {
      className: "Avatar ArenaBattleStartPost-avatarFallback"
    }, ((_name$ = name[0]) != null ? _name$ : '?').toUpperCase())), nameEl, stats && m("div", {
      className: "ArenaBattleStartPost-playerStats"
    }, m("span", {
      className: "ArenaBattleStartPost-stat ArenaBattleStartPost-stat--wins",
      title: app.translator.trans('forumaker-arena.lib.stats.wins')
    }, m("i", {
      className: "fas fa-trophy"
    }), " ", (_stats$wins = stats.wins) != null ? _stats$wins : 0), m("span", {
      className: "ArenaBattleStartPost-stat ArenaBattleStartPost-stat--losses",
      title: app.translator.trans('forumaker-arena.lib.stats.losses')
    }, m("i", {
      className: "fas fa-skull"
    }), " ", (_stats$losses = stats.losses) != null ? _stats$losses : 0), m("span", {
      className: "ArenaBattleStartPost-stat ArenaBattleStartPost-stat--draws",
      title: app.translator.trans('forumaker-arena.lib.stats.draws')
    }, m("i", {
      className: "fas fa-handshake"
    }), " ", (_stats$draws = stats.draws) != null ? _stats$draws : 0)));
  }
  view() {
    var _this$challengerUser;
    const content = this.attrs.post.content();
    if (!content) return null;
    const fallback = id => app.translator.trans('forumaker-arena.forum.battle.player_fallback', {
      id: String(id)
    });
    const challengerName = ((_this$challengerUser = this.challengerUser) == null ? void 0 : _this$challengerUser.displayName()) || content.challengerName || fallback(content.challengerId);
    return m("div", {
      className: "ArenaBattleStartPost EventPost"
    }, m("div", {
      className: "ArenaBattleStartPost-wrap"
    }, m("div", {
      className: "ArenaBattleStartPost-versus"
    }, this.playerColumn(this.challengerUser, content.challengerName || fallback(content.challengerId)), m("span", {
      className: "ArenaBattleStartPost-vs"
    }, "VS"), this.playerColumn(this.opponentUser, content.opponentName || fallback(content.opponentId)))), m("div", {
      className: "ArenaStartPost"
    }, m("div", {
      className: "ArenaStartPost-icon"
    }, m("i", {
      className: "fas fa-swords"
    })), m("div", {
      className: "ArenaStartPost-body"
    }, m("div", {
      className: "ArenaStartPost-title"
    }, app.translator.trans('forumaker-arena.forum.battle_start.first_turn', {
      name: m("strong", null, challengerName)
    })), m("div", {
      className: "ArenaStartPost-subtitle"
    }, app.translator.trans('forumaker-arena.forum.battle_start.first_turn_subtitle')))));
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ArenaBattleStartPost', ArenaBattleStartPost);